export default __webpack_public_path__ + "static/media/recruit_table_icon_6.661c236d.svg";